var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTownHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add_TownHouse",
    "data-name": "Add TownHouse",
    transform: "translate(-16 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M88,408h7.4l2.467,2.467V415.4H88Z",
    transform: "translate(-60.9 -331.566)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M117.667,57.867v5.015L104.1,52.933,86.833,65.267,69.567,52.933,56,62.882V57.867L69.567,48,86.833,60.333,104.1,48Z",
    transform: "translate(-33.833 -27.066)",
    fill: "#cacac9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M43.1,433.863a3.7,3.7,0,1,0-1.684-6.994,4.933,4.933,0,1,0-4.482,6.994Z",
    transform: "translate(-13.53 -345.096)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M88,254.2V235.7a3.7,3.7,0,1,1,7.4,0v18.5Z",
    transform: "translate(-60.9 -182.7)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M168,232h8.633v9.867H168Z",
    transform: "translate(-128.567 -182.7)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 4.933,
    cy: 4.933,
    r: 4.933,
    transform: "translate(30.8 32.034)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M95.533,37.567,77.033,24,59.767,36.333,42.5,24,24,37.567v6.167L42.5,30.167,59.767,42.5,77.033,30.167l18.5,13.567Z",
    transform: "translate(-6.767 -6.766)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M369.867,408h-7.4L360,410.467V415.4h9.867Z",
    transform: "translate(-290.967 -331.566)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M387.694,433.863a3.7,3.7,0,1,1,1.684-6.994,4.933,4.933,0,1,1,4.482,6.994Z",
    transform: "translate(-311.261 -345.096)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M383.4,254.2V235.7a3.7,3.7,0,1,0-7.4,0v18.5Z",
    transform: "translate(-304.5 -182.7)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M288,232h8.633v9.867H288Z",
    transform: "translate(-230.067 -182.7)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 4.933,
    cy: 4.933,
    r: 4.933,
    transform: "translate(65.333 32.034)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M82.467,236.333v-7.4a2.467,2.467,0,0,1,4.933,0v7.4h2.467v-7.4a4.933,4.933,0,0,0-9.867,0v7.4Z",
    transform: "translate(-54.133 -175.933)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M169.867,224h-8.633A1.233,1.233,0,0,0,160,225.233V235.1a1.233,1.233,0,0,0,1.233,1.233h8.633A1.233,1.233,0,0,0,171.1,235.1v-9.867A1.233,1.233,0,0,0,169.867,224Zm-1.233,2.467v2.467h-6.167v-2.467Zm-6.167,7.4V231.4h6.167v2.467Z",
    transform: "translate(-121.8 -175.933)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M80,192h2.467v2.467H80Z",
    transform: "translate(-54.133 -148.866)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M216,192h2.467v2.467H216Z",
    transform: "translate(-169.167 -148.866)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M110.167,124.333A6.167,6.167,0,1,0,104,118.167,6.167,6.167,0,0,0,110.167,124.333Zm-3.488-4.933h2.255v2.255a3.718,3.718,0,0,1-2.255-2.255Zm4.721,2.255V119.4h2.255a3.718,3.718,0,0,1-2.255,2.255Zm2.255-4.721H111.4v-2.255A3.718,3.718,0,0,1,113.655,116.933Zm-4.721-2.255v2.255h-2.255A3.718,3.718,0,0,1,108.933,114.679Z",
    transform: "translate(-74.433 -81.2)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M85.067,75.2V35.783l2.971,2.179A1.233,1.233,0,0,0,90,36.967V30.8a1.233,1.233,0,0,0-.5-.994L71,16.239a1.233,1.233,0,0,0-1.446-.009L53,28.051,36.45,16.23A1.233,1.233,0,0,0,35,16.239L16.5,29.806a1.233,1.233,0,0,0-.5.995v6.167a1.233,1.233,0,0,0,1.963.995l2.971-2.179V75.2H23.4V72.734H36.555l4.111,3.083V87.534h-6.83a4.931,4.931,0,0,0-5.407-7.266,6.165,6.165,0,1,0-9.96,7.267H16V90H90V87.534H87.53a6.164,6.164,0,1,0-9.96-7.267,4.93,4.93,0,0,0-5.407,7.267h-6.83V75.817l4.111-3.083H82.6V75.2ZM82.6,62.867H69.033a1.233,1.233,0,0,0-.74.247l-4.933,3.7a1.233,1.233,0,0,0-.493.987v9.867H54.233v-41.3L70.257,24.923,82.6,33.974ZM70.267,65.334h2.467v4.933H70.267ZM62.867,82.6H54.233V80.134h8.633ZM43.133,80.134h8.633V82.6H43.133ZM18.467,31.425,35.743,18.756l16.54,11.815a1.233,1.233,0,0,0,1.434,0l16.54-11.815L87.533,31.425v3.108L71,22.406A1.233,1.233,0,0,0,69.55,22.4L53,34.218,36.45,22.4A1.233,1.233,0,0,0,35,22.406L18.467,34.533Zm17.276-6.5L51.767,36.368v41.3H43.133V67.8a1.233,1.233,0,0,0-.493-.987l-4.933-3.7a1.233,1.233,0,0,0-.74-.247H23.4V33.974Zm-.01,40.411v4.933H33.267V65.334ZM23.4,70.267V65.334h2.467v4.933Zm4.933-4.933H30.8v4.933H28.333Zm9.867,5.55V66.567l2.467,1.85v4.317Zm4.933,14.183h8.633v2.467H43.133ZM23.4,87.534a3.7,3.7,0,1,1,3.362-5.245,1.233,1.233,0,0,0,1.683.582,2.437,2.437,0,0,1,1.122-.27,2.467,2.467,0,0,1,0,4.933Zm50.567-2.467A2.47,2.47,0,0,1,76.433,82.6a2.438,2.438,0,0,1,1.122.27,1.233,1.233,0,0,0,1.683-.582A3.7,3.7,0,1,1,82.6,87.534H76.433a2.47,2.47,0,0,1-2.467-2.467ZM54.233,87.534V85.067h8.633v2.467Zm11.1-19.117,2.467-1.85v4.317l-2.467,1.85Zm9.867,1.85V65.334h2.467v4.933Zm4.933,0V65.334H82.6v4.933Z",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M372.933,224A4.939,4.939,0,0,0,368,228.933v7.4h2.467v-7.4a2.467,2.467,0,1,1,4.933,0v7.4h2.467v-7.4A4.939,4.939,0,0,0,372.933,224Z",
    transform: "translate(-297.733 -175.933)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M289.867,224h-8.633A1.233,1.233,0,0,0,280,225.233V235.1a1.233,1.233,0,0,0,1.233,1.233h8.633A1.233,1.233,0,0,0,291.1,235.1v-9.867A1.233,1.233,0,0,0,289.867,224Zm-1.233,2.467v2.467h-6.167v-2.467Zm-6.167,7.4V231.4h6.167v2.467Z",
    transform: "translate(-223.3 -175.933)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M416,192h2.467v2.467H416Z",
    transform: "translate(-338.333 -148.866)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M280,192h2.467v2.467H280Z",
    transform: "translate(-223.3 -148.866)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M328,118.167A6.167,6.167,0,1,0,334.167,112,6.167,6.167,0,0,0,328,118.167Zm2.679,1.233h2.255v2.255a3.718,3.718,0,0,1-2.255-2.255Zm4.721,2.255V119.4h2.255A3.718,3.718,0,0,1,335.4,121.655Zm2.255-4.721H335.4v-2.255A3.718,3.718,0,0,1,337.655,116.933Zm-4.721-2.255v2.255h-2.255A3.718,3.718,0,0,1,332.933,114.679Z",
    transform: "translate(-263.9 -81.2)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M99.1,408.633V403.7a1.233,1.233,0,0,0-.361-.872l-2.467-2.467A1.234,1.234,0,0,0,95.4,400H88v2.467h6.889l1.744,1.744v4.423Z",
    transform: "translate(-60.9 -324.8)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M354.828,400.361l-2.467,2.467a1.233,1.233,0,0,0-.361.872v4.933h2.467v-4.423l1.744-1.744H363.1V400h-7.4a1.233,1.233,0,0,0-.872.361Z",
    transform: "translate(-284.2 -324.8)",
    fill: "#0b5647"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTownHouse);
export default __webpack_public_path__ + "static/media/TownHouse.affc3fbf003406a55784557fc72ed49d.svg";
export { ForwardRef as ReactComponent };